import type { SportsApi } from "@/v2/api/metadata/sports";
import { createFeedConfigDialogApi } from "@/v2/kits/feed-config";
import { sportId } from "../../shared";

export function createSportFeedConfigApi(sportsApi: SportsApi) {
  return createFeedConfigDialogApi(({ values }) => sportId(values), {
    getFeedTypeMappings: sportsApi.getFeedTypeMappings.bind(sportsApi),
    getFeedInstanceMappings: sportsApi.getFeedInstanceMappings.bind(sportsApi),
    updateEntity: async (entityId, payload) => {
      await sportsApi.update(entityId, payload);
    },
  });
}
